import {PersistentTrigger, TimeWindowCondition, type TriggerCondition, type TriggerFactory} from "./triggers";

export class ImmediateTrigger extends PersistentTrigger {
    public constructor(protected element: Element, triggerConditions: TriggerCondition[], ...triggerCallbacks: (() => void)[]) {
        super(triggerConditions, ...triggerCallbacks);

        this.trigger();
    }
}

export class ImmediateTriggerFactory implements TriggerFactory {
    public createTrigger(element: Element, callback: () => void): ImmediateTrigger {
        return new ImmediateTrigger(element, TimeWindowCondition.timeWindowCondition(element), callback);
    }
}